import DiscountBanner from "./DiscountBanner"
import GiftBanner from "./GiftBanner"
import LotteryBanner from "./LotteryBanner"

import {
	FragmentType,
	getFragmentData,
	graphql,
} from "@/public/gql/__generated__"

// design 参照: frontend/design/public/rereservation.pen
// - GIFT (えらべるPay):  Frame rPg4N 内 "Gift Campaign Section" (id: gft4N)
// - DISCOUNT (500円OFF): Frame 2ddNw 内 "Gift Campaign Section" (id: HgFb9)
// - LOTTERY (10万円抽選): pen デザインなし。LotteryRoulette.module.scss のコメント参照
// - GIFT_CANDIDATE (予算ありギフト): GIFT と同じ GiftBanner でバッジを「数量限定」にし「予算に達し次第終了」の注意書きを足して出す
//
// fragment Document 自体は外部に export せず、必要なら unmaskIncentive() helper 経由で扱う.
// LOTTERY 固有の表示フィールドはここに置かず、LotteryBanner 側の fragment を nest spread する
// (fragment collocation: 子コンポーネントが自分の必要フィールドを所有する).
const rereservationIncentiveBannerFragment = graphql(/* GraphQL */ `
	fragment rereservationIncentiveBanner on RereservationIncentiveOutput {
		price
		type
		...lotteryBanner
	}
`)

// 親が incentive の type/price だけ知りたい時に使う helper.
// fragment Document 自体は非公開、親は IncentiveSummary 経由でアクセスする.
export type IncentiveSummary = {
	type: "GIFT" | "DISCOUNT" | "LOTTERY" | "GIFT_CANDIDATE"
	price: number
}
export const unmaskIncentive = (
	incentive: FragmentType<typeof rereservationIncentiveBannerFragment>
): IncentiveSummary => {
	return getFragmentData(rereservationIncentiveBannerFragment, incentive)
}

type Props = {
	incentive: FragmentType<typeof rereservationIncentiveBannerFragment>
	cancelId: string
	customerName: string
	originPrice: number
	// LOTTERY のときだけ使う. 抽選の案内を見せたことをサーバに記録するのはページ側の責務.
	onLotteryShown: () => void
}

const RereservationIncentiveBanner = ({
	incentive,
	cancelId,
	customerName,
	originPrice,
	onLotteryShown,
}: Props) => {
	const summary = getFragmentData(
		rereservationIncentiveBannerFragment,
		incentive
	)

	if (summary.type === "LOTTERY") {
		// summary は自分の fragment の unmask 結果なので、nest spread した
		// lotteryBanner fragment の ref を含む. 子はこれを自分で unmask する.
		return (
			<LotteryBanner
				incentive={summary}
				cancelId={cancelId}
				customerName={customerName}
				onShown={onLotteryShown}
			/>
		)
	}

	if (summary.type === "GIFT" || summary.type === "GIFT_CANDIDATE") {
		return (
			<GiftBanner
				price={summary.price}
				cancelId={cancelId}
				customerName={customerName}
				originPrice={originPrice}
				isBudgetLimited={summary.type === "GIFT_CANDIDATE"}
			/>
		)
	}
	return (
		<DiscountBanner
			price={summary.price}
			cancelId={cancelId}
			customerName={customerName}
			originPrice={originPrice}
		/>
	)
}

export default RereservationIncentiveBanner
